import * as React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import styled from 'styled-components'
import Modal from '../../../stories/organisms/Modal/Modal'
import FlashMessage from '../flash-message/FlashMessage'
import DuplicatedJobFlashMessage from '../flash-message/DuplicatedJob'
import { BaseLayoutStyle } from './BaseLayout.style'
import type { State } from '../../../state/reducers/index'
import { hideDialog, hideFlashMessage, hideProductModal, removeToaster } from '../../../state/actions/ui/ui'
import ProductTypeDialog from '../../../stories/organisms/ProductTypeDialog/ProductTypeDialog'
import { createJob } from '../../../state/actions/job/job'
import { useAppSelector } from '../../../state/reducers/types'
import { createDraft } from '../../../state/actions/draft/draft'
import { selectEntitlements } from '../../draft/suggest-products/SuggestProducts'

import Toast from '../../../stories/atoms/Toast/Toast'

type BaseLayoutProps = {
  children: React.ReactNode
}

const ToastContainer = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: fixed;
  right: 0;
  bottom: 36px;
  z-index: 11;
  padding: 12px;
`

const BaseLayout: React.FunctionComponent<BaseLayoutProps> = ({ children }) => {
  const dispatch = useDispatch()
  const displayModal = useAppSelector(state => state.ui.displayProductModal)

  const entitlements = useAppSelector(selectEntitlements)
  const toasters = useAppSelector(state => state.ui.toasters)
  const {
    flashMessage: { type },
    modal: { showDialog, title, content, size, primaryAction, secondaryAction },
  } = useSelector((state: State) => state.ui)

  return (
    <BaseLayoutStyle>
      {type === 'duplicatedJob' && (
        <FlashMessage flashMessageHiddenCallback={hideFlashMessage}>
          <DuplicatedJobFlashMessage />
        </FlashMessage>
      )}
      {children}
      <Modal
        isOpen={showDialog}
        onClose={() => dispatch(hideDialog())}
        {...{ title, content, size, primaryAction, secondaryAction }}
      />
      <ProductTypeDialog
        isOpen={displayModal}
        onClose={() => dispatch(hideProductModal())}
        onStartStaticPricedDraft={() => {
          dispatch(hideProductModal())
          dispatch(createDraft({ product: null }))
        }}
        onStartVariablePricedDraft={() => {
          dispatch(hideProductModal())
          dispatch(createJob({ product: entitlements.performanceBased[0] }))
        }}
      />

      <ToastContainer>
        {toasters.map(toaster => (
          <Toast
            key={toaster.id}
            variant={toaster.variant}
            title={toaster.title}
            onClose={() => dispatch(removeToaster(toaster.id))}
          >
            {toaster.description}
          </Toast>
        ))}
      </ToastContainer>
    </BaseLayoutStyle>
  )
}

export default BaseLayout
